import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/pages/Home.vue';
import CreateList from './components/pages/CreateList.vue';
import ViewList from './components/pages/ViewList.vue';
import notFound from './components/pages/notFound.vue';

Vue.use(Router)

//Define routes
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/list/new',
      name: 'create-list',
      component: CreateList,
      props: true
    },
    {
      path: '/list/:list_id/edit',
      name: 'edit-list',
      component: CreateList,
      props: true,
      meta: {
        title: "Edit list",
      }
    },
    {
      path: '/list/:list_id',
      name: 'view-list',
      component: ViewList,
      props: true,
      meta: {
        title: "View list",
      }
    },
    { path: '/manifest.json'},
    { path: '/serviceWorker.js'},
    { path: '/img/*'},
    { path: '/images/*'},
    { path: "*", component: notFound }
  ]
});

//Define guards
/*
function loginGuard(to, from, next) {
  if (
    typeof store.getters.token == 'undefined' 
  ) {
    next({ name: 'home' });
  } else {
    next();
  }
}
*/
